(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["landing-addon"] && !Shopify.designMode) return;
  try {
    (function () {
    const trigger  = document.querySelector('.addon-image-trigger');
    const popup    = document.getElementById('addonImagePopup');
    const backdrop = popup?.querySelector('.addon-image-popup__backdrop');

    if (!trigger || !popup) return;

    const open = (e) => {
      e.preventDefault();
      e.stopPropagation();
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };

    const close = () => {
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    trigger.addEventListener('click', open);
    backdrop.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["landing-bundle"] && !Shopify.designMode) return;
  try {
    const dialog = document.getElementById('helpDialog');
  const openBtn = document.getElementById('qsn-mark');
  const closeBtn = document.getElementById('closeDialog');
  const body = document.body;

  const openModal = () => {
    dialog.showModal();
    body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    dialog.close();
    body.style.overflow = '';
  };

  openBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);

  dialog.addEventListener('cancel', () => {
    body.style.overflow = '';
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) closeModal();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rh-landing-bundle"] && !Shopify.designMode) return;
  try {
    const dialog = document.getElementById('helpDialog');
  const openBtn = document.getElementById('qsn-mark');
  const closeBtn = document.getElementById('closeDialog');
  const body = document.body;

  const openModal = () => {
    dialog.showModal();
    body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    dialog.close();
    body.style.overflow = '';
  };

  openBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);

  dialog.addEventListener('cancel', () => {
    body.style.overflow = '';
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) closeModal();
  });
  } catch(e) { console.error(e); }
})();

})();
